import React from 'react';
import BaseIcon, { IconProps } from './Base.icon';

interface StarIconProps {
  size?: number;
  color?: string;
  className?: string;
}

const StarIcon: React.FC<StarIconProps> = ({ size, color }: IconProps) => {
  return (
    <BaseIcon width={size} height={size} viewBox="0 0 24 24">
      <path
        fill={color}
        d="M21.947 9.179a1.001 1.001 0 0 0-.868-.676l-5.701-.453l-2.467-5.461a.998.998 0 0 0-1.822-.001L8.622 8.05l-5.701.453a1 1 0 0 0-.619 1.713l4.213 4.107l-1.49 6.452a1 1 0 0 0 1.53 1.057L12 18.202l5.445 3.63a1.001 1.001 0 0 0 1.517-1.106l-1.829-6.4l4.536-4.082c.297-.268.406-.686.278-1.065"
      />
    </BaseIcon>
  );
};

export default StarIcon;
